import { useParams } from "react-router";
import { useVbsCalculationShowQuery } from "@/services/backend/vbs/calculations/api/calculation-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  TreatmentComponent,
  TreatmentComponentSkeleton,
} from "@/services/backend/vbs/treatments/components/treatment-component";
import { Column } from "@/services/backend/vbs/treatments/lib/treatment-component-state";

export function CalculationTreatmentRoute() {
  const { calculationId } = useParams();
  const {
    data: calculation,
    isLoading,
    error,
  } = useVbsCalculationShowQuery({ id: calculationId! });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return <TreatmentComponentSkeleton />;
  }

  return (
    <TreatmentComponent
      treatmentId={calculation!.treatmentId}
      availableColumns={[
        Column.Position,
        Column.ComponentKind,
        Column.ComponentData,
        Column.Cycle,
        Column.Formula,
        Column.CleanTime,
        Column.Comment,
        Column.Actions,
      ]}
      defaultColumns={[
        Column.Position,
        Column.ComponentKind,
        Column.ComponentData,
        Column.Cycle,
        Column.CleanTime,
        Column.Comment,
        Column.Actions,
      ]}
    />
  );
}
